import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledFooterModelLinks = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.size.static150};

  @media (min-width: ${Breakpoints.b1280}px) {
    gap: ${theme.size.static400};
    align-items: center;
    flex-direction: row;
  }
`
);

export const StyledConfiguratorCTA = styled.div`
  button {
    width: 100%;
    text-wrap: nowrap;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    button {
      width: auto;
    }
  }
`;
